<template lang="html">
  <div class="card" ref="hot" :style="selfStyle">
    <div class="card-body">
      <slot name="name">
        <div class="card-header">
          置顶
        </div>
      </slot>
      <!-- <DynamicItem @click="goDetails" @updateItem="(reload) => updateItem(item, reload)" v-for="item of tops" :key="`tops${item.id}`" v-bind="item" /> -->
      <List v-model="loading" :el="el" @onload="getDynamic">
        <DynamicItem @click="goDetails" @updateItem="(reload) => updateItem(item, reload)" v-for="(item, index) of dynamic" :key="`dynamic${index}${item.id}`" v-bind="item" />
      </List>
    </div>
    <!-- <transition name="bounce">
       <div  v-if="loading" :style="{'padding-bottom': isAndroid ? 0 : '50px' }" class="loading">加载过程中</div>
      </transition> -->
    <Loading :loading="false"/>
  </div>
</template>

<script>
import { get } from '../utils/request'
import Loading from './Loading.vue'
import { createNamespacedHelpers } from 'vuex'
import DynamicItem from '../components/DynamicItem'
import { isAndroid } from '../utils/utils'
import { set, get as getUser, remove } from '../utils/token'
import List from './list'
const { mapGetters } = createNamespacedHelpers('refresh')
export default {
  props: {
    selfStyle: {
      type: String,
      default: ''
    }
  },
  components: {
    Loading,
    DynamicItem,
    List
  },
  data () {
    return {
      loading: false,
      isAndroid: isAndroid(),
      dynamic: [],
      tops: [],
      count: 0,
      page: 1,
      el: this.$parent.$refs.find
    }
  },
  async mounted () {
    await this.getTops()
    // await this.getDynamic(() => {
    //   this.scrollLocation()
    // })
    // await this.addUpRefresh()
  },
  computed: {
    ...mapGetters({
      getDownRefresh: 'getDownRefresh'
    })
  },
  methods: {
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = getUser('scrollFind')
        if (scrollTop) {
          this.$parent.$refs.find.scrollTop = scrollTop
          remove('scrollFind')
        }
      })
    },
    goDetails () {
      set('scrollFind', this.$parent.$refs.find.scrollTop)
    },
    getTops () {
      const user = getUser('user')
      if (!user) {
        return
      }
      const promise = get({
        url: `/circle/getRecommendCircle?user=${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.tops = detail
        }
      })
    },
    addUpRefresh () {
      const el = this.$parent.$refs.find
      if (!el) {
        return
      }
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, dynamic, page } = this
          if (count > dynamic.length) {
            this.loading = true
            this.page = page + 1
            this.getDynamic()
          }
        }
      })
    },
    updateItem (item, reload) {
      Object.assign(item, reload)
    },
    getDynamic (callback) {
      const user = getUser('user')
      if (!user) {
        return
      }
      const promise = get({
        url: `/circle/hotPoint?page=${this.page}&size=10&user=${user.id}`
      })
      promise.then(res => {
        let { data: { code, detail: { count, data } } } = res
        if (Object.is(code, 200)) {
          this.count = count
          data = data.map(item => {
            const items = Object.assign({ }, item.circle, {
              tags: [item.tag]
            })
            return items
          })
          this.dynamic = [...this.dynamic, ...data]
          this.loading = false
          if (callback) {
            callback()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.label {
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  margin-right: 10px;
  font-size: 12px;
  border: 1px solid #FF5722;
  background: none;
  color: #FF5722;
}
.card {
  box-sizing: border-box;
  background: transparent;
  padding: 0 7.5px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 2px;
  .card-body {
    background-color: #fff;
    .card-header {
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      border-bottom: 1px dotted #E9E9E9;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 768px) {
  .card {
    padding:0 7.5px !important;
  }
}
</style>
